'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// components
import { ModalStepper } from 'dumb';

// batch view
import WaitingTimeScheduleEntriesBatchStepList from './components/waitingTimeScheduleEntriesBatchStepList';

// phrases
import phrases from './../../waitingTimeScheduleEntries.phrases';

import './waitingTimeScheduleEntriesModalBatch.css';

class WaitingTimeScheduleEntriesModalBatch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loadingModal: false,
		};
	}

	_batchSubmit() {
		const {
			batchList,
			handleClose,
			addWaitingTimeScheduleEntry,
			waitingTimeSchedule,
		} = this.props;

		this.setState(() => ({
			loadingModal: true,
		}));

		const payload = batchList.map((entry) => {
			return {
				waiting_time_schedule: waitingTimeSchedule.id,
				products: entry.products,
				minutes: entry.minutes,
			};
		});

		addWaitingTimeScheduleEntry({ batch: payload })
			.then(() => handleClose())
			.finally(() =>
				this.setState(() => ({
					loadingModal: false,
				}))
			);
	}

	render() {
		const {
			modalVisible,
			handleClose,
			batchList,
			editBatchListItem,
			removeBatchListItem,
			addBatchListItemRow,
		} = this.props;

		const steps = [
			{
				component: (
					<WaitingTimeScheduleEntriesBatchStepList
						batchList={batchList}
						editBatchListItem={editBatchListItem}
						removeBatchListItem={removeBatchListItem}
						productRecommendationUrl={this.productRecommendationUrl}
						tileLayoutUrl={this.tileLayoutUrl}
						ingredientConfigurationUrl={this.ingredientConfigurationUrl}
						addBatchListItemRow={addBatchListItemRow}
					/>
				),
				title: phrases.MODAL_BATCH_STEP_LIST_TITLE,
				isValid: true,
				onNext: () => this._batchSubmit(),
				loading: this.state.loadingModal,
				confirmButtonLabel: phrases.MODAL_BATCH_STEP_LIST_CONFIRM_BUTTON_LABEL,
				defaultStyles: false,
				noScroll: false,
			},
		];

		return modalVisible ? (
			<ModalStepper
				isOpen={modalVisible}
				steps={steps}
				showStep={false}
				onClose={handleClose}
			/>
		) : null;
	}
}

WaitingTimeScheduleEntriesModalBatch.propTypes = {
	modalVisible: PropTypes.bool,
	handleClose: PropTypes.func,
	batchList: PropTypes.array,
	editBatchListItem: PropTypes.func,
	removeBatchListItem: PropTypes.func,
	addBatchListItemRow: PropTypes.func,
	addWaitingTimeScheduleEntry: PropTypes.func,
	waitingTimeSchedule: PropTypes.object,
};

export default WaitingTimeScheduleEntriesModalBatch;
